import { Reducer } from 'react'
import { PlanState, PlanTypes, PlanAction } from '../types/settings'

const initialState: PlanState = {
  access_token: '',
  isAuthenticated: false,
  loading: false,
  email: '',
  error: '',
  phone_number: '',
}

const planReducer: Reducer<PlanState, PlanAction> = (
  state = initialState,
  action: PlanAction
): PlanState => {
  switch (action.type) {
    case PlanTypes.GET_PLANS_REQUEST:
      return {
        ...state,
        email: '',
        loading: true,
        error: '',
      }
    case PlanTypes.GET_PLANS_SUCCESS:
      return {
        ...state,
        email: action.payload.email,
        loading: false,
        error: '',
      }
    case PlanTypes.GET_PLANS_ERROR:
      return {
        ...state,
        error: action.payload.error,
      }
      case PlanTypes.GET_FAQS_REQUEST:
        return {
          ...state,
          error: action.payload.error,
        }
        case PlanTypes.GET_FAQS_SUCCESS:
          return {
            ...state,
            error: action.payload.error,
          }
          case PlanTypes.GET_FAQS_ERROR:
            return {
              ...state,
              error: action.payload.error,
            }
            case PlanTypes.UPDATE_AVATAR_REQUEST:
              return {
                ...state,
                error: action.payload.error,
              }
              case PlanTypes.UPDATE_AVATAR_SUCCESS:
                return {
                  ...state,
                  error: action.payload.error,
                }
                case PlanTypes.UPDATE_AVATAR_ERROR:
                  return {
                    ...state,
                    error: action.payload.error,
                  }
    default:
      return state
  }
}

export { planReducer }
